export const checkIfEmpty = (string) => {
  return string === '' || string === undefined ? '' : string + '/';
}

const productPrice = (product) => {
  return product.isBundle ? product?.bundleProductsList?.reduce((a, b) => a + +b.priceFrom, 0) : product.priceFrom
}

const sortingObject = {
  'price-asc': (a, b) => productPrice(a) - productPrice(b),
  'price-desc': (a, b) => productPrice(b) - productPrice(a),
  'relevance': () => 0,
}

export const sortByOption = (arr, option) => {
  return arr.slice().sort(sortingObject[option]);
}

export const formatProductGroups = (productGroups, selectedGroup) => {
  let activeFound = false;

  const formatFunction = (productGroup) => {
    if (activeFound) {
      return productGroup;
    }

    const matchingSubcategory = productGroup?.subcategories?.find(subcategory => subcategory?._id === selectedGroup?._id);

    if (matchingSubcategory) {
      activeFound = true;
      return {
        ...productGroup,
        subcategories: productGroup.subcategories.map(subcategory => ({
          ...subcategory,
          active: subcategory._id === selectedGroup?._id,
        })),
      };
    } else if (productGroup._id === selectedGroup?._id) {
      activeFound = true;
      return {
        ...productGroup,
        active: true,
      };
    }

    return productGroup;
  };

  return productGroups?.map(formatFunction);
}